"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$ = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$outboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$inboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$ = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$outboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$inboundSchema = void 0;
exports.getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityToJSON = getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityToJSON;
exports.getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityFromJSON = getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityFromJSON;
exports.getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestToJSON = getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestToJSON;
exports.getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestFromJSON = getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$;
(function (GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$) {
    /** @deprecated use `GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$inboundSchema` instead. */
    GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$.inboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$inboundSchema;
    /** @deprecated use `GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$outboundSchema` instead. */
    GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$.outboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$outboundSchema;
})(GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$ || (exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$ = GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$ = {}));
function getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityToJSON(getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity) {
    return JSON.stringify(exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$outboundSchema
        .parse(getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity));
}
function getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetSecurity' from JSON`);
}
/** @internal */
exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$inboundSchema = z.object({
    person_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "person_id": "personId",
    });
});
/** @internal */
exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$outboundSchema = z.object({
    personId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        personId: "person_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$;
(function (GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$) {
    /** @deprecated use `GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$inboundSchema` instead. */
    GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$.inboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$inboundSchema;
    /** @deprecated use `GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$outboundSchema` instead. */
    GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$.outboundSchema = exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$outboundSchema;
})(GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$ || (exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$ = GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$ = {}));
function getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestToJSON(getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest) {
    return JSON.stringify(exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$outboundSchema
        .parse(getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest));
}
function getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGetRequest' from JSON`);
}
//# sourceMappingURL=getpersonswithsignificantcontrolbyidcompaniespersonswithsignificantcontrolpersonidget.js.map